import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-audio-help',
  templateUrl: './audio-help.component.html',
  styleUrls: ['./audio-help.component.scss'],
})
export class AudioHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
